/* ----------------------------------------
    Imports
---------------------------------------- */

import { ApiService } from './ApiService';

/* ----------------------------------------
    API Service
---------------------------------------- */

export class OrganisationService extends ApiService {

    /* ----------------------------------------
        Constructor
    ---------------------------------------- */

    protected constructor(store) {
        super('', store);
    }

    public async getSearchResults(query: string) {
        return this.get(`/search/${ query }`);
    }

    public async postOrganisation(data: [object]) {
        return this.post('/organisation', data);
    }

    public async getOrganisation(id: string = '') {
        return this.get(`/organisation/${ id }`);
    }

    public async getOrganisationUsers(id: string = '') {
        return this.get(`/organisation/${ id }/users`);
    }

    public async updateOrganisationUserRole(id: string = '', userId: string = '') {
        return this.get(`/organisation/${ id }/admin/${ userId }`);
    }

    public async removeOrganisationUser(id: string = '', userId: string = '') {
        return this.get(`/organisation/${ id }/unlink/${ userId }`);
    }

    public async getOrganisationProjects(id: string = '') {
        return this.get(`/organisation/${ id }/projects`);
    }

    public async getOrganisationList() {
        return this.get(`/user/organisations/`);
    }

    public async putOrganisation(id: string = '', data: object = {}) {
        return this.put(`/organisation/${ id }`, data);
    }
}
